"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ResponseError_1 = require("../error/ResponseError");
var TokenType_1 = require("./model/TokenType");
function parseAuthorizationHeader(authorizationHeader) {
    var arr = authorizationHeader.split(' ');
    if (arr.length !== 2) {
        throw new ResponseError_1.ResponseError(403, 'Invalid authorization header');
    }
    var token = {
        type: arr[0],
        value: arr[1]
    };
    if (!(token.type === TokenType_1.TokenType.Bearer || token.type === TokenType_1.TokenType.Basic || token.type === TokenType_1.TokenType.Tracker || token.type === TokenType_1.TokenType.Terminal)) {
        throw new ResponseError_1.ResponseError(403, 'Invalid token type');
    }
    return token;
}
function getAuthorizationHeaderBasic(login, password) {
    return 'Basic ' + Buffer.from(login + ':' + password).toString('base64');
}
exports.default = { getAuthorizationHeaderBasic: getAuthorizationHeaderBasic, parseAuthorizationHeader: parseAuthorizationHeader };
//# sourceMappingURL=TokenUtils.js.map